import React from "react";
import "./brandMark.scss";

/**
 * Lockup merek LOKA Publishing: cincin "O" + wordmark.
 *
 * Dibangun dari SVG inline, bukan memakai public/lokalogo.png, karena tulisan
 * pada berkas itu berwarna putih — hanya cocok di atas latar gelap dan lenyap
 * di mode terang. Di sini warna cincinnya diambil dari logo aslinya
 * (#005090 dan #68C0C8) dan dibiarkan tetap di kedua tema — warna logo tidak
 * ikut berganti tema — sementara teksnya memakai token supaya selalu terbaca.
 */
const BrandMark = ({ className = "" }) => {
  return (
    <div className={`brand-mark ${className}`.trim()}>
      <svg
        className="brand-mark-ring"
        viewBox="0 0 40 40"
        role="img"
        aria-label="LOKA Publishing"
      >
        <circle cx="20" cy="20" r="14" fill="none" stroke="#005090" strokeWidth="7" />
        <circle cx="20" cy="20" r="11" fill="#68C0C8" />
      </svg>
      {/* Sudah diwakili aria-label pada SVG di atas; disembunyikan agar nama
          mereknya tidak dibacakan dua kali. */}
      <span className="brand-mark-words" aria-hidden="true">
        <span className="brand-mark-name">LOKA</span>
        <span className="brand-mark-sub">PUBLISHING</span>
      </span>
    </div>
  );
};

export default BrandMark;
